import { render, staticRenderFns } from "./TheHeroSection.vue?vue&type=template&id=24ca29fb&scoped=true&"
import script from "./TheHeroSection.vue?vue&type=script&lang=js&"
export * from "./TheHeroSection.vue?vue&type=script&lang=js&"
import style0 from "./TheHeroSection.vue?vue&type=style&index=0&id=24ca29fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca29fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VParallax,VRow})
